// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__Cc6xf","footer":"Form_footer__33VKf"};